import React, { useState, useEffect } from "react";
import { WhatsappIcon } from "../../../libs/SVGIcons";
import axios from "../../../axios";
import { useHistory } from "react-router-dom";

export const WhatsappDeviceStatusElement = ({ lang }) => {
  const [data, setData] = useState({ loaded: false, has_device: false, status: "none" });
  const history = useHistory();

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await axios.get("whatsapp/my-device-status");
        if (response.data && response.data.data) {
          setData({
            loaded: true,
            has_device: response.data.data.has_device,
            status: response.data.data.status
          });
        }
      } catch (error) {
        console.error("Failed to fetch whatsapp device status", error);
        setData({ loaded: true, has_device: false, status: "none" });
      }
    };

    fetchStatus();
    const interval = setInterval(fetchStatus, 120000); // Poll every 2 mins
    return () => clearInterval(interval);
  }, []);

  if (!data.loaded || !data.has_device) {
    return null;
  }

  const { status } = data;

  let color = "#9e9e9e"; // none (gray)
  let pulseClass = "";
  let statusText = window.sys_app_translate ? window.sys_app_translate("Not Active", lang) : "Not Active";
  if (status === "connected") {
    color = "#4caf50"; // green
    pulseClass = "whatsapp-pulse-green";
    statusText = window.sys_app_translate ? window.sys_app_translate("Connected", lang) : "Connected";
  } else if (status === "disconnected") {
    color = "#f44336"; // red
    pulseClass = "whatsapp-pulse-red";
    statusText = window.sys_app_translate ? window.sys_app_translate("Disconnected", lang) : "Disconnected";
  }

  let numberItemTitleStyle = {
    color: "#199B8B",
    marginLeft: "0.71rem",
  };
  if (lang === "ar") {
    numberItemTitleStyle = {
      color: "#199B8B",
      marginRight: "0.71rem",
    };
  }

  return (
    <>
      <style>
        {`
          .whatsapp-pulse-green {
            box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7);
            animation: pulse-green 2s infinite;
          }
          @keyframes pulse-green {
            0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7); }
            70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(76, 175, 80, 0); }
            100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(76, 175, 80, 0); }
          }
          .whatsapp-pulse-red {
            box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.7);
            animation: pulse-red 2s infinite;
          }
          @keyframes pulse-red {
            0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.7); }
            70% { transform: scale(1); box-shadow: 0 0 0 10px rgba(244, 67, 54, 0); }
            100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(244, 67, 54, 0); }
          }
          .whatsapp-card-hover {
            transition: all 0.3s ease;
          }
          .whatsapp-card-hover:hover {
            transform: translateY(-5px);
            box-shadow: 0 10px 20px rgba(25, 155, 139, 0.15);
          }
        `}
      </style>
      <div 
        className="col-6 col-sm-3 number-item-button" 
        onClick={() => history.push("/app/whatsapp-devices/view-all")}
      >
        <div
          className="clickable whatsapp-card-hover"
          style={{
            paddingTop: "1.25rem",
            paddingBottom: "1.25rem",
            paddingRight: "1.1rem",
            paddingLeft: "1.1rem",
            backgroundColor: "white",
            borderRadius: "20px",
            position: "relative",
            border: "1px solid rgba(25, 155, 139, 0.1)",
            height: "100%",
          }}
        >
          <div className="d-flex align-items-center justify-content-start">
            <span className="icon">
               <WhatsappIcon style={{ width: "24px", height: "24px", fill: color }} />
            </span>
            <span
              className="title inter-semi-bold font-size-1"
              style={numberItemTitleStyle}
            >
              {window.sys_app_translate ? window.sys_app_translate("WhatsApp", lang) : "WhatsApp"}
            </span>
          </div>
          <div className="d-flex align-items-center justify-content-start mt-2">
            <div 
              className={pulseClass}
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: color,
                marginRight: lang === "ar" ? "0" : "8px",
                marginLeft: lang === "ar" ? "8px" : "0",
              }}
            />
            <span className="number inter-bold" style={{ color: color, fontSize: "0.9rem" }}>
              {statusText}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
